export const filter = {
  id : '',  
  name: '',
  graphic_type_id: null,
  total_working_day: null,
  created_at: '',
  updated_at: ''  
};
